var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchOrang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5038 17.8811L16.1784 13.5557C17.0721 12.2088 17.5952 10.596 17.5952 8.8623C17.5952 4.16463 13.7733 0.342773 9.07568 0.342773C4.37801 0.342773 0.556152 4.16463 0.556152 8.8623C0.556152 13.56 4.37801 17.3818 9.07568 17.3818C10.8094 17.3818 12.4221 16.8587 13.7691 15.965L18.0945 20.2904C18.759 20.9558 19.8392 20.9558 20.5038 20.2904C21.1691 19.625 21.1691 18.5464 20.5038 17.8811ZM3.11201 8.8623C3.11201 5.57376 5.78714 2.89863 9.07568 2.89863C12.3642 2.89863 15.0393 5.57376 15.0393 8.8623C15.0393 12.1508 12.3642 14.826 9.07568 14.826C5.78714 14.826 3.11201 12.1508 3.11201 8.8623Z",
    fill: "rgba(227, 55, 69, 1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchOrang);
export default __webpack_public_path__ + "static/media/searchOrang.58934c6e7fda462dd993855ebe2f80cc.svg";
export { ForwardRef as ReactComponent };